import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import { SharedResultPage } from './SharedResultPage.tsx'
import { TypeComparePage } from './TypeComparePage.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/r/:token" element={<SharedResultPage />} />
        <Route path="/compare" element={<TypeComparePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
